import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

type NavigateOptions = { replace?: boolean; state?: unknown };

export function useViewTransitionNavigation() {
  const navigate = useNavigate();

  const navigateWithTransition = useCallback(
    (to: string, options?: NavigateOptions) => {
      if (document.startViewTransition) {
        document.startViewTransition(() => {
          navigate(to, options);
        });
      } else {
        navigate(to, options);
      }
    },
    [navigate],
  );

  return navigateWithTransition;
}
